import type { PropsWithChildren } from 'react';

/** 状态语义色（固定，不可混用） */
export type BadgeTone = 'ok' | 'run' | 'warn' | 'alert' | 'idle' | 'frozen' | 'brand';

export interface BadgeProps {
  tone?: BadgeTone;
  className?: string;
  title?: string;
}

/**
 * 状态标签。
 *
 * <Badge tone="ok">已完成</Badge>
 * <Badge tone="frozen">已冻结</Badge>
 */
export default function Badge({
  tone = 'idle',
  className,
  title,
  children,
}: PropsWithChildren<BadgeProps>) {
  return (
    <span className={['badge', `badge--${tone}`, className].filter(Boolean).join(' ')} title={title}>
      {children}
    </span>
  );
}
